import React from "react";
// import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import {
    FiCheckCircle, FiZap, FiTarget, FiTrendingUp, FiMapPin, FiCode
} from "react-icons/fi";
import { FaShip, FaPlaneDeparture, FaCrown, FaRocket } from "react-icons/fa";

import "./CaseStudy.css";

// Animation Variants
const fadeUp = {
    hidden: { opacity: 0, y: 30 },
    visible: (i) => ({
        opacity: 1,
        y: 0,
        transition: { delay: i * 0.1, duration: 0.6, ease: [0.25, 0.46, 0.45, 0.94] }
    })
};

const scaleIn = {
    hidden: { opacity: 0, scale: 0.8 },
    visible: (i) => ({
        opacity: 1,
        scale: 1,
        transition: { delay: i * 0.1, duration: 0.5, type: "spring", stiffness: 200 }
    })
};

const stagger = {
    visible: { transition: { staggerChildren: 0.12 } }
};

// Case Study Data
const caseStudies = [
    {
        number: 1,
        icon: FiCode,
        title: "German EdTech Company",
        subtitle: "Develops Tech Products and Smart Class Room",
        highlights: ["Client is a German EdTech Company", "Develops Tech Products and Smart Class Room", "Operates Across 3 countries, 80 Associates"],
        technologies: ["Full Stack", "Web Application", "Cloud"],
        challenges: [
            "Ability to scale quickly to help their end customers",
            "Availability of tech talent in ERP and BI Platforms",
            "Margin pressure due to reduced rate of billing",
            "Quick scale up",
            "Improve Profit margin",
        ],
        solutions: [
            "Build initial team of 20 engineers, Architect, Senior Developers, Testing and UI-UX experts",
            "Product Ownership and Tech Redesign. Develop and Release the product version",
            "A joint team across two continents and worked in joint model",
            "Communication & Governance",
        ],
        benefits: [
            { text: "Reduce the cost by 43%", highlight: true },
            { text: "Improved customer support, 33% Reduced case", highlight: true },
            { text: "Products released on time" },
            { text: "No Backlog, Full team across Onsite and Offshore" },
        ],
        shape: "sphere",
        shapeColor: "#2bb677",
    },
    {
        number: 2,
        icon: FaShip,
        title: 'Norwegian IT Services Company',
        subtitle: 'IT Services across domains',
        highlights: ['Client is a Norwegian IT Services Company', 'Operates Across 6 countries, 500 Associates'],
        technologies: ['Unit4 ERP', 'Web Application', 'BI Tools'],
        challenges: [
            'Ability to scale quickly to help their end customers',
            'Availability of tech talent in ERP and BI Platforms',
            'Margin pressure due to reduced rate of billing',
            'Quick scale up',
            'Improve Profit margin',
        ],
        solutions: [
            'Build initial team of 6 engineers, across ERP, Power BI and Full Stack',
            'Worked in Hybrid Model. The Project Manager, Service Delivery and majority of team in Europe and a team in India.',
            'A joint team across continents in joint delivery model',
            'Communication & Governance',
        ],
        benefits: [
            { text: 'We could start the customer project in time', highlight: true },
            { text: 'Improved customer support across 24X7 and non-business hour support', highlight: true },
            { text: 'Products released on time' },
            { text: 'Full team across Onsite and Offshore' },
        ],
        shape: 'torus',
        shapeColor: '#465ba0',
    },
    {
        number: 3,
        icon: FiMapPin,
        title: 'Berlin Based PropTech Company',
        subtitle: 'Product Engineering · Future vision to operate Across Europe',
        highlights: ['Client is a Berlin Based PropTech Company', 'Presently operating in Berlin'],
        technologies: ['Node JS', 'React JS', 'MySQL', 'Web & Mobile Applications', 'Jitsi'],
        challenges: [
            'Ability to scale quickly to help their end customers',
            'Margin pressure',
            'Architecture and design issues',
            'Gaps in Automation',
        ],
        solutions: [
            'Improve Profit margin due to Cost effective offshore team',
            'Changed architecture for scaling',
            'Implemented automation of recurring production issues',
        ],
        benefits: [
            { text: '40% Cost Reduction', highlight: true },
            { text: 'Scalable Architecture', highlight: true },
            { text: 'We could start the customer project in time' },
        ],
        shape: 'octahedron',
        shapeColor: '#2bb677',
    },
    {
        number: 4,
        icon: FaPlaneDeparture,
        title: 'US Based Aviation Tech Startup',
        subtitle: 'Aviation Tech Startup · Operates Across US',
        highlights: ['Client is US based Startup', 'Aviation Tech Startup'],
        technologies: ['Node JS', 'iOS', 'React JS', 'MySQL', 'AI/ML', 'Cloud', 'RPA', 'Web & Mobile Applications'],
        challenges: [
            'Seed funded organization with limited funding',
            'Had established marketing and business team but tech team was not available',
        ],
        solutions: [
            'SpringUp Labs set up technical team and help desk in India',
            'Co-ordination with various technical vendors and provided complete system integration',
            'New age technologies like AI/ML, RPA, Chatbots and JS full stack used to fulfill business needs',
        ],
        benefits: [
            { text: 'Cost Effective solution', highlight: true },
            { text: '24 X 7 Help Desk', highlight: true },
            { text: 'All tech functions from offshore' },
        ],
        shape: 'dodecahedron',
        shapeColor: '#465ba0',
    },
    {
        number: 5,
        icon: FaCrown,
        title: 'Norway Based Startup',
        subtitle: 'Customer Management Platform · Operates Across EU',
        highlights: ['Client is Norway based Startup', 'Customer Management Platform'],
        technologies: ['Node JS', 'REACT', 'AWS', 'Android', 'iOS', 'AI/ML', 'Cloud', 'RPA', 'Web & Mobile Applications'],
        challenges: [
            'Seed funded organization with limited funding',
            'Had established marketing and business team but tech team was not available',
            'Scalability and competency needed as not available',
        ],
        solutions: [
            'SpringUp Labs set up CTO Office, Technical team, Implementation Team in India',
            'Entire Product Management was driven from India',
            'Built a team of 15 people to develop initial versions of the platform. And providing the support/enhancement support now',
        ],
        benefits: [
            { text: 'Cost Effective solution', highlight: true },
            { text: 'Effective Scale Up', highlight: true },
            { text: 'All tech functions are supported from offshore' },
        ],
        shape: 'sphere',
        shapeColor: '#2bb677',
    },
    {
        number: 6,
        icon: FaCrown,
        title: 'Sweden/UK Based Startup',
        subtitle: 'Intellectual Property Management Software · Operates Across EU',
        highlights: ['Client is Sweden/UK based Startup', 'IP Management Software'],
        technologies: ['Node JS', 'REACT', 'AWS', '.Net', 'AI/ML', 'Cloud'],
        challenges: [
            'Scalability and competency needed as not available',
        ],
        solutions: [
            'Worked in Hybrid Model. The Project Manager, Service Delivery and majority of tech team in Europe and a team in India.',
            'Joint team across continents in joint delivery model',
            'Communication & Governance',
        ],
        benefits: [
            { text: 'Cost Effective Solution', highlight: true },
            { text: 'Effective Scale Up', highlight: true },
            { text: 'Collaborated Tech Team.' },
        ],
        shape: 'torus',
        shapeColor: '#465ba0',
    },
];

const CaseStudy = () => {
    return (
        <div className="cs-page">
            {/* HERO SECTION */}
            <section className="cs-hero">
                <div className="em-hero-circle-1" />
                <div className="em-hero-circle-2" />
                <div className="cs-hero__bg">
                    {[...Array(5)].map((_, i) => (
                        <motion.div
                            key={i}
                            className="cs-hero__orb"
                            style={{
                                width: 200 + i * 80,
                                height: 200 + i * 80,
                                top: `${10 + i * 15}%`,
                                left: `${60 + i * 5}%`,
                            }}
                            animate={{ y: [0, -20, 0], x: [0, 10, 0] }}
                            transition={{ duration: 6 + i, repeat: Infinity, ease: "easeInOut" }}
                        />
                    ))}
                </div>

                <div className="cs-hero__container">
                    <motion.div initial="hidden" animate="visible" variants={stagger}>
                        <motion.div variants={fadeUp} custom={0} className="cs-hero__badge">
                            <FaRocket className="cs-hero__badge-icon" />
                            <span className="cs-hero__badge-text">Success Stories</span>
                        </motion.div>

                        <motion.h1 variants={fadeUp} custom={1} className="cs-hero__title">
                            Our Success <span className="gcc-hero-highlight">Story</span>
                        </motion.h1>

                        <motion.p variants={fadeUp} custom={2} className="cs-hero__desc">
                            Embark on a journey of success guided by our exceptional Leaders and Senior Management Team,
                            whose visionary prowess and strategic acumen navigate us through uncharted territories of innovation.
                        </motion.p>
                    </motion.div>
                </div>
            </section>

            {/* CASE STUDIES */}
            {caseStudies.map((cs, i) => (
                <CaseStudyCard key={cs.number} data={cs} index={i} />
            ))}

            {/* CTA SECTION */}
            {/* <section className="cs-cta">
        <div className="cs-cta__bg" />
        <div className="cs-cta__container">
          <motion.div initial="hidden" whileInView="visible" viewport={{ once: true }} variants={stagger}>
            <motion.h2 variants={fadeUp} custom={0} className="cs-cta__title">
              Ready to Write Your <span className="gradient-text">Success Story</span>?
            </motion.h2>
            <motion.p variants={fadeUp} custom={1} className="cs-cta__desc">
              Let's build your future-ready team together. Start your journey today.
            </motion.p>
            <motion.button variants={fadeUp} custom={2} className="cs-cta__button">
              Schedule a Consultation <FiArrowRight />
            </motion.button>
          </motion.div>
        </div>
      </section> */}
        </div>
    );
};

// Unified Case Study Card Component
const CaseStudyCard = ({ data, index }) => {
    const isEven = index % 2 === 0;
    const Icon = data.icon;

    return (
        <div className="">
            <section className={`cs-section ${!isEven ? "cs-section--alt" : ""}`}>
                <div className="cs-container container">
                    {/* Header */}
                    <motion.div
                        className="cs-header"
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true }}
                        variants={stagger}
                    >
                        <motion.div variants={fadeUp} custom={0} className="cs-header__inner">
                            <div className="cs-header__icon-wrap">
                                <div className="cs-header__icon-box">
                                    {/* You can replace with your MiniScene3D if you have it, otherwise keep icon */}
                                    <Icon size={48} />
                                </div>
                                <div className="cs-header__number">{data.number}</div>
                            </div>
                            <div>
                                <span className="cs-header__label">Case Study {data.number}</span>
                                <h2 className="cs-header__title">{data.title}</h2>
                                <p className="cs-header__subtitle">{data.subtitle}</p>
                            </div>
                        </motion.div>
                    </motion.div>

                    {/* Highlights */}
                    <motion.div
                        className="cs-highlights"
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true }}
                        variants={stagger}
                    >
                        <motion.h3 variants={fadeUp} custom={0} className="cs-section-heading">
                            <div className="cs-section-heading__icon cs-section-heading__icon--primary">
                                <FiTarget />
                            </div>
                            Highlights
                        </motion.h3>
                        <div className="cs-highlights__list">
                            {data.highlights.map((h, i) => (
                                <motion.div key={i} variants={scaleIn} custom={i} className="cs-highlight-chip">
                                    <div className="cs-highlight-chip__circle-tr" />
                                    <div className="cs-highlight-chip__circle-bl" />
                                    <Icon className="cs-highlight-chip__icon" />
                                    <span className="cs-highlight-chip__text">{h}</span>
                                </motion.div>
                            ))}
                        </div>
                    </motion.div>

                    {/* Technology Details */}
                    <motion.div
                        className="cs-technologies"
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true }}
                        variants={stagger}
                    >
                        <motion.h3 variants={fadeUp} custom={0} className="cs-section-heading">
                            <div className="cs-section-heading__icon cs-section-heading__icon--secondary">
                                <FiCode />
                            </div>
                            Technology Details
                        </motion.h3>
                        <div className="cs-technologies__list">
                            {data.technologies.map((t, i) => (
                                <motion.span key={i} variants={scaleIn} custom={i} className="cs-tech-badge">
                                    {t}
                                </motion.span>
                            ))}
                        </div>
                    </motion.div>

                    {/* Three Columns */}
                    <motion.div
                        className="cs-columns"
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true }}
                        variants={stagger}
                    >
                        {/* Challenges */}
                        <motion.div variants={fadeUp} custom={0} className="cs-card cs-card--challenges">
                            <div className="cs-card__circle-tr" />
                            <div className="cs-card__circle-bl" />
                            <div className="cs-card__bar" />
                            <div className="cs-card__body">
                                <h4 className="cs-card__title">
                                    <div className="cs-card__title-icon">
                                        <FiTrendingUp />
                                    </div>
                                    Business Challenges
                                </h4>
                                <ul className="cs-list">
                                    {data.challenges.map((t, i) => (
                                        <motion.li
                                            key={i}
                                            initial={{ opacity: 0, x: -15 }}
                                            whileInView={{ opacity: 1, x: 0 }}
                                            viewport={{ once: true }}
                                            transition={{ delay: 0.3 + i * 0.08 }}
                                            className="cs-list__item"
                                        >
                                            <span className="cs-list__num">{i + 1}</span>
                                            {t}
                                        </motion.li>
                                    ))}
                                </ul>
                            </div>
                        </motion.div>

                        {/* Solution */}
                        <motion.div variants={fadeUp} custom={1} className="cs-card cs-card--solution">
                            <div className="cs-card__circle-tr" />
                            <div className="cs-card__circle-bl" />
                            <div className="cs-card__bar" />
                            <div className="cs-card__body">
                                <h4 className="cs-card__title">
                                    <div className="cs-card__title-icon">
                                        <FiCode />
                                    </div>
                                    Our Solution
                                </h4>
                                <ul className="cs-list">
                                    {data.solutions.map((t, i) => (
                                        <motion.li
                                            key={i}
                                            initial={{ opacity: 0, x: -15 }}
                                            whileInView={{ opacity: 1, x: 0 }}
                                            viewport={{ once: true }}
                                            transition={{ delay: 0.3 + i * 0.08 }}
                                            className="cs-list__item"
                                        >
                                            <FiCheckCircle className="cs-list__check" />
                                            {t}
                                        </motion.li>
                                    ))}
                                </ul>
                            </div>
                        </motion.div>

                        {/* Benefits */}
                        <motion.div variants={fadeUp} custom={2} className="cs-card cs-card--benefits">
                            <div className="cs-card__circle-tr" />
                            <div className="cs-card__circle-bl" />
                            <div className="cs-card__bar" />
                            <div className="cs-card__body">
                                <h4 className="cs-card__title">
                                    <div className="cs-card__title-icon">
                                        <FiZap />
                                    </div>
                                    Benefits
                                </h4>
                                <div className="cs-list">
                                    {data.benefits.map((b, i) => (
                                        <motion.div
                                            key={i}
                                            initial={{ opacity: 0, y: 10 }}
                                            whileInView={{ opacity: 1, y: 0 }}
                                            viewport={{ once: true }}
                                            transition={{ delay: 0.3 + i * 0.08 }}
                                            className={`cs-benefit ${b.highlight ? "cs-benefit--highlight" : "cs-benefit--normal"}`}
                                        >
                                            <FiCheckCircle className={b.highlight ? "cs-benefit__icon--highlight" : "cs-benefit__icon--normal"} />
                                            {b.text}
                                        </motion.div>
                                    ))}
                                </div>
                            </div>
                        </motion.div>
                    </motion.div>
                </div>
            </section>
        </div>
    );
};

export default CaseStudy;